module.exports = __webpack_public_path__ + "static/media/1.25bec6f3.svg";